// extracted by mini-css-extract-plugin
export default {"menu":"Navigation_menu__h4ZpV","active":"Navigation_active__eo+Dg"};